import axios from "axios";
import { serviceHelper } from "./helper";

const instance = axios.create();

instance.defaults.headers.common["Visoplan-Client-Id"] =
  serviceHelper.getClientId();

export default instance;
